export default __webpack_public_path__ + "0c122c7a43cb00b6b68e7bff5d2fbf47.png";